module.exports = new __parcel__URL__("login_poster_3.a1b8c47d.png").toString();